const tabTableinit = () => {

    const tabs = document.querySelectorAll('.tab');
    const tableItem = document.querySelectorAll('.tab-table__table-wrap');

    function switchTab(event) {
        const clickedTab = event.target;
        const tabName = clickedTab.getAttribute('data-name');

        if (clickedTab.classList.contains('active')) return; // Prevent re-activating the same tab

        tabs.forEach(tab => tab.classList.remove('active'));  // Remove active class from all tabs
        clickedTab.classList.add('active');  // Add active class to the clicked tab

        tableItem.forEach(tabItem => tabItem.classList.remove('show'));  // Hide all table items

        document.querySelectorAll(`.${tabName}`).forEach(activeContent => {
            activeContent.classList.add('show');  // Show corresponding content
        });
    }

    tableItem.forEach(item => {
        item.classList.remove('show');  // Hide all table items initially
    });

    tabs.forEach(tab => {
        tab.addEventListener('click', switchTab);  // Add click event listener to each tab
    });

    // Trigger the click on the first tab if one exists (show on load)
    const firstTab = document.querySelector('.tab');
    if (firstTab) {
        firstTab.classList.add('active'); // Ensure the first tab is active
        const tabName = firstTab.getAttribute('data-name');
        document.querySelectorAll(`.${tabName}`).forEach(activeContent => {
            activeContent.classList.add('show');  // Show corresponding content for the first tab
        });
    }

}

export { tabTableinit }
